export default __webpack_public_path__ + "static/posterGladiator-514f27fe2d8e80db3f70210834067b1f.svg";